export default __webpack_public_path__ + "static/media/logo1024x1024.dbf8d056.png";